import { render, staticRenderFns } from "./Additional-Documents.vue?vue&type=template&id=789d82bc&scoped=true"
import script from "./Additional-Documents.vue?vue&type=script&lang=js"
export * from "./Additional-Documents.vue?vue&type=script&lang=js"
import style0 from "./Additional-Documents.vue?vue&type=style&index=0&id=789d82bc&prod&scoped=true&lang=css"
import style1 from "./Additional-Documents.vue?vue&type=style&index=1&id=789d82bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789d82bc",
  null
  
)

export default component.exports